var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gender-icon",class:{
    'male-icon-color': _vm.gender === 'MALE',
    'female-icon-color': _vm.gender === 'FEMALE'
  }},[_c('el-tooltip',{attrs:{"content":_vm.tooltipText}},[_c('i',{class:_vm.genderIcon})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }